import {
  AttendContactLateEntity,
} from './attendContactLateEntity';
import { ChildId } from './valueObjects/childId';
import { LateDateTime } from './valueObjects/lateDateTime';
import { Memo } from './valueObjects/memo';
import { NurseryId } from './valueObjects/nurseryId';
import { ParentId } from './valueObjects/parentId';

import type {
  AttendContactLatePropsPub,
  AttendContactLatePropsPvt,
} from './attendContactLateEntity';
import type { EntityDataPubType } from '@/domain/entityBase';
import type { EntityDataPubNotNullType, EntityPubNotNullType } from '@/domain/entityPub';
import type { AttendContactLateJsonPub, AttendContactLateJsonPvt } from '@/types/domain/attendContact/entities/attendContactLateEntity';

import { FactoryPub } from '@/domain/factoryPub';

/**
 * AttendContactLateFactory
 */
export class AttendContactLateFactory extends FactoryPub<
  AttendContactLateEntity,
  AttendContactLatePropsPvt,
  AttendContactLateJsonPvt,
  AttendContactLatePropsPub,
  AttendContactLateJsonPub
> {
  comparePub = (
    a: EntityDataPubType<AttendContactLateJsonPvt, AttendContactLateJsonPub>,
    b: EntityDataPubType<AttendContactLateJsonPvt, AttendContactLateJsonPub>,
  ) => {
    const da = new Date(a.data.lateDateTime);
    const db = new Date(b.data.lateDateTime);
    return da < db ? 1 : -1;
  };

  create(
    props: AttendContactLatePropsPvt,
    propsPub: EntityPubNotNullType<AttendContactLatePropsPub>,
  ): AttendContactLateEntity {
    return new AttendContactLateEntity(props, propsPub);
  }

  createFromEntityDataPub(
    props: EntityDataPubNotNullType<AttendContactLateJsonPvt, AttendContactLateJsonPub>,
  ): AttendContactLateEntity {
    return this.create({
      nurseryId: NurseryId.create(props.data.nurseryId),
      parentId: ParentId.create(props.data.parentId),
      childId: ChildId.create(props.data.childId),
      lateDateTime: LateDateTime.create(new Date(props.data.lateDateTime)),
      memo: Memo.create(props.data.memo),
    }, {
      sendId: props.pub.sendId,
      replyId: props.pub.replyId,
      data: {},
    });
  }
}
